import { faHeart as faHeartRegular } from "@fortawesome/pro-regular-svg-icons/faHeart";
import { faHeart as faHeartSolid } from "@fortawesome/pro-solid-svg-icons/faHeart";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

interface IProps extends Omit<MprcIconFaProps, "icon"> {
    variant: "solid" | "regular";
}

export const IconInterest: React.FC<IProps> = (props) => {
    return <MprcIconFa {...props} icon={props.variant == "regular" ? faHeartRegular : faHeartSolid} />;
};
